import { Box, Container, Flex, Button } from '@chakra-ui/react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { colors } from 'constants/constants';
import { TwoColumnImageAndTextBlock as TwoColumnImageAndTextBlockType } from 'types/umbraco';


export default function TwoColumnImageAndTextBlock({
  imageOrVideo,
  backgroundColor,
  text,
  textColor,
  button,
  buttonStyle,
  reverse = false,
  textPosition = 'Center',
}: TwoColumnImageAndTextBlockType['properties']): JSX.Element {
  const router = useRouter();
  
  const image = imageOrVideo && Array.isArray(imageOrVideo) && imageOrVideo.length > 0 
    ? imageOrVideo[0] 
    : null;
  
  const buttonData = button && Array.isArray(button) && button.length > 0 
    ? button[0] 
    : null;
  
  const bgColor = backgroundColor && backgroundColor.value 
    ? backgroundColor.value 
    : '#fff';

  const textColorValue = textColor && textColor.value 
    ? textColor.value 
    : '#000';

 const getJustifyValue = (position: string) => {
    switch (position) {
      case 'Top':
        return 'flex-start';
      case 'Bottom':
        return 'flex-end';
      case 'Center':
      default:
        return 'center';
    }
  };


  const isVideo = image && image.mediaType === 'umbracoMediaVideo';

  if ((!image || !image.url) && (!text || !text.markup)) {
    return null;
  }

  return (
    <Box bg={bgColor} pos="relative" py={{ base: 6, md: 12 }}>
      <Container maxW="7xl">
        <Flex
          gap={{ base: 6, md: 12 }}
          flexDirection={reverse ? 'row-reverse' : 'row'}
          align="center"
          flexWrap={{ base: 'wrap', md: 'nowrap' }}
        >
          {image && image.url && (
            <Box 
              flex={{ base: '0 0 100%', md: 1 }} 
              position="relative" 
              minH={{ base: '250px', sm: '300px', md: '400px' }} 
              width="100%"
            >
              {isVideo ? (
                <video
                  autoPlay={true}
                  loop={true}
                  playsInline={true}
                  muted={true}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '12px',
                  }}
                >
                  <source src={image.url} />
                </video>
              ) : (
                <Image
                  src={image.url}
                  fill
                  alt={image.name || 'Block image'}
                  style={{ objectFit: 'cover', borderRadius: '12px' }}
                  priority
            
                />
              )}
            </Box>
          )}

          <Box 
            flex={{ base: '0 0 100%', md: 1 }}
            display="flex"
            flexDirection="column"
            justifyContent={getJustifyValue(textPosition)}
            minH={{ base: 'auto', md: '400px' }}
            py={{ base: 4, md: 0 }}
          >
            {text && text.markup && (
              <Box 
                className="umb-text-block"
                color={textColorValue}
                mb={6}
                dangerouslySetInnerHTML={{ __html: text.markup }}
              />
            )}
            {buttonData && buttonData.title && (
              <Button
               as="a"
                href={buttonData.route?.path || buttonData.url}
                target={buttonData.target}
                variant={buttonStyle?.toLowerCase() || 'orange'}
                alignSelf={{ base: 'flex-start' }}
                _hover={{ opacity: 0.85 }}
              >
                {buttonData.title}
              </Button>
            )}
          </Box>
        </Flex>
      </Container>
    </Box>
  );
}